export function systemHeaderState({ mapMode, session, publicView, readiness, realtimeStatus, dataSource }) {
  if (mapMode) return {
    ok: true,
    status: "MAP READY",
    source: session ? "DID VIEW" : "PUBLIC CATALOG",
    sourceWarning: false,
  };

  if (publicView) {
    const realtimeNominal = realtimeStatus?.available === true
      && realtimeStatus?.connected === true
      && realtimeStatus?.hasData === true;
    return {
      ok: realtimeNominal,
      status: realtimeNominal ? "SYSTEM NOMINAL" : "SYSTEM CHECK",
      source: realtimeNominal ? "PUBLIC REALTIME + CHAIN" : "CHAIN ONLY",
      sourceWarning: !realtimeNominal,
    };
  }

  const ready = readiness?.ready === true;
  const chainOnly = dataSource === "chain-only";
  return {
    ok: ready,
    status: ready ? "SYSTEM NOMINAL" : "SYSTEM CHECK",
    source: chainOnly ? "CHAIN ONLY" : "BE + CHAIN",
    sourceWarning: chainOnly,
  };
}
